import React, { useContext, useState } from "react";
import { Linking, ScrollView, StyleSheet, Text, View } from "react-native";
import BetterAlert from "../../components/BetterAlert";
import Item from "./components/Item";
import { AuthContext } from "../../contexts/auth";
import Icon from "react-native-vector-icons/Ionicons";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import { urlApp } from "../../services/Config";
import PageTitle from "../../components/PageTitle";
import { IS_WEB } from "../../services/Config";

export default function Perfil({ navigation }) {
  const [showAlert, setShowAlert] = useState({});
  const { setIsSignUp, emailUser, isAdmin } = useContext(AuthContext);

  return (
    <PageTitle title={"PERFIL"}>
      {/* <View style={styles.perfil}>
        <Icon
          name="ios-person-circle-outline"
          size={128}
          color={Colors.BLACK}
        />
        <Text style={styles.email}>{emailUser ? emailUser : ""}</Text>
      </View> */}
      <ScrollView>
        <Item
          icon={"card-account-details-outline"}
          title={"Dados da Conta"}
          action={() => navigation.navigate("AccountInfo")}
          key={2}
        />
        <Item
          icon={"ticket-confirmation-outline"}
          title={"Credencial Digital"}
          action={() => navigation.navigate("DigitalCredential")}
          key={11}
        />
        <Item
          icon={"file-document-outline"}
          title={"Meus Documentos"}
          action={() => navigation.navigate("MyDocuments")}
          key={12}
        />
        <Item
          icon={"car-outline"}
          title={"Meus veículos"}
          constract={true}
          action={() => navigation.navigate("MyVehicles")}
          key={10}
        />
        <Item
          icon={"calendar-month-outline"}
          title={"Contratos"}
          constract={true}
          action={() => navigation.navigate("ContractList")}
          key={3}
        />
        <Item
          icon={"cog-outline"}
          title={"Preferências"}
          action={() => navigation.navigate("Preferences")}
          key={4}
        />
        <Item
          icon={"history"}
          title={"Meus pagamentos"}
          action={() => navigation.navigate("PaymentHistoric")}
          key={5}
        />
        {IS_WEB ? (
          <Item
            icon={"clock-outline"}
            title={"Pagamentos desta sessão"}
            action={() => navigation.navigate("PaymentSessionHistory")}
            key={12}
          />
        ) : (
          <></>
        )}
        <Item
          icon={"information-outline"}
          title={"Ajuda"}
          action={() => navigation.navigate("About")}
          key={6}
        />
        <Item
          icon={"phone-outline"}
          title={"Entre em contato"}
          action={() => navigation.navigate("Contact")}
          key={7}
        />
        <Item
          icon={"cursor-default-outline"}
          title={"Site da Trevo"}
          action={() => Linking.openURL(urlApp)}
          key={8}
        />
        {isAdmin && (
          <Item
            icon={"shield-account-outline"}
            title={"Painel Admin"}
            action={() => navigation.navigate("AdminPanel")}
            key={13}
          />
        )}
        <Item
          icon={"logout"}
          title={"Sair"}
          action={() =>
            setShowAlert({
              type: "info",
              title: "Atenção",
              message: "Deseja realmente sair?",
              show: true,
              cancelText: "Não",
              confirmText: "Sim",
              pressCancel: () => {
                setShowAlert({ ...showAlert, show: false });
              },
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
                setIsSignUp(false);
              },
            })
          }
          key={9}
        />
      </ScrollView>
      <BetterAlert {...showAlert} />
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  perfil: {
    justifyContent: "center",
    alignItems: "center",
  },
  email: {
    color: Colors.GRAY_DARK,
    margin: 4,
    fontSize: Fonts.FONT_SIZE_16,
  },
});
